import { BeneficiaryFilterItem } from '@repo/shared/dtos/beneficiary'
import { StructuredDataSchemaItem } from '@repo/shared/dtos/structured-data'
import { useSelector } from 'react-redux'

import { selectFilterAndSchemaItemList } from '@/store/beneficiary-list-filters/selectors'
import { removeFilter, updateFilter } from '@/store/beneficiary-list-filters/slice'
import { useStoreDispatch } from '@/store/hooks'

import FilterItem from './filters/FilterItem'

type FilterAndSchemaItemList = {
  filter: BeneficiaryFilterItem
  schemaItem: StructuredDataSchemaItem
}[]

export function BeneficiaryListFiltersWrapper() {
  const dispatch = useStoreDispatch()

  const filterAndSchemaItemList = useSelector(selectFilterAndSchemaItemList)

  const handleUpdateFilter = (filter: BeneficiaryFilterItem) => dispatch(updateFilter(filter))

  const handleRemoveFilter = (filter: BeneficiaryFilterItem) => dispatch(removeFilter(filter))
  return (
    <BeneficiaryListFilters
      data={filterAndSchemaItemList}
      onRemove={handleRemoveFilter}
      onUpdate={handleUpdateFilter}
    />
  )
}

export function BeneficiaryListFilters({
  data,
  onRemove,
  onUpdate,
}: {
  data: FilterAndSchemaItemList
  onRemove: (filter: BeneficiaryFilterItem) => void
  onUpdate: (filter: BeneficiaryFilterItem) => void
}) {
  return (
    <>
      {data.map(({ filter, schemaItem }) => (
        <div className="shrink-0" key={filter.key}>
          <FilterItem
            filter={filter}
            schemaItem={schemaItem}
            onChange={onUpdate}
            onRemove={onRemove}
          />
        </div>
      ))}
    </>
  )
}
